/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Publish({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.4 14.5a.6.6 0 1 0 1.2 0V8.949l1.976 1.975a.6.6 0 0 0 .848-.848l-2.999-3a.6.6 0 0 0-.195-.13.6.6 0 0 0-.655.13l-3 3a.6.6 0 0 0 .85.848L7.4 8.95z" /><path fill="currentColor" d="M15 1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1 0-1h2V2h-3.623c-.96 0-1.84.543-2.27 1.403-.07.141-.107.297-.107.456V5.25a.5.5 0 0 1-1 0V3.859c0-.159-.037-.315-.108-.456A2.54 2.54 0 0 0 5.122 2H1.5v10h2a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5v-11A.5.5 0 0 1 1 1h4.123C6.275 1 7.342 1.56 8 2.48A3.54 3.54 0 0 1 10.877 1z" /></svg>;
}
;